import { Stack, Text, makeStyles } from '@fluentui/react';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { CloseButton } from 'common/components/Buttons';
import { UnsavedIndicator } from 'common/components/UnsavedIndicator';
import { useCommonStyles } from 'common/styles';
import { EntityType } from 'common/types/utility';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DataAccessPolicyValues } from '../types';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    width: '100%',
    backgroundColor: theme.palette.neutralLighterAlt,
    zIndex: 99,
    cursor: 'move',
  },
  row: {
    height: 30,
  },
}));

interface HeaderProps {
  onClose: () => void;
  onDelete: () => void;
  isNew: boolean;
  _isDeletable: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  onClose,
  onDelete,
  isNew,
  _isDeletable,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  const {
    formState: { isDirty },
  } = useFormContext<DataAccessPolicyValues>();

  return (
    <Stack
      horizontal
      className={styles.container}
      horizontalAlign="space-between"
      verticalAlign="center"
      tokens={{
        padding: 20,
      }}
    >
      <Stack
        horizontal
        grow
        tokens={{ childrenGap: 10 }}
        className={styles.row}
      >
        <Text variant="xLarge" className={commonStyles.colorThemePrimary}>
          {isNew ? 'Create Data Access Policy' : 'Edit Data Access Policy'}
        </Text>
        <UnsavedIndicator visible={isDirty} />
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 10 }}>
        {!isNew && (
          <ActionMessageModal
            entityType={EntityType.DataAccessPolicy}
            disabled={!_isDeletable}
            onConfirm={onDelete}
          />
        )}
        <CloseButton onClick={onClose} />
      </Stack>
    </Stack>
  );
};
